// Centralized fallback images.
// Used whenever Firebase data has no image set, OR a stored image URL
// fails to load (broken link, deleted file, etc). All inline SVG data
// URIs so they never depend on an external host and can never 404.

export const DEFAULT_COMPANY_LOGO =
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Crect width='24' height='24' fill='%23f2f2f2'/%3E%3Cpath d='M4 21V7l8-4 8 4v14h-5v-6h-6v6H4z' fill='%23a0a0a0'/%3E%3C/svg%3E";

export const DEFAULT_SCHOOL_LOGO = DEFAULT_COMPANY_LOGO;

export const DEFAULT_SKILL_ICON =
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Crect width='24' height='24' rx='5' fill='%23e8e8e8'/%3E%3Cpath d='M9 8l-4 4 4 4M15 8l4 4-4 4' stroke='%23a0a0a0' stroke-width='2' fill='none' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E";

export const DEFAULT_PROJECT_IMAGE =
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 300 180'%3E%3Crect width='300' height='180' fill='%23f2f2f2'/%3E%3Cpath d='M110 120l25-30 20 24 15-18 30 24H110z' fill='%23c7c7c7'/%3E%3Ccircle cx='125' cy='70' r='12' fill='%23c7c7c7'/%3E%3C/svg%3E";

// Small helper so every <img> in the app wires up the same way:
// <img src={src || DEFAULT_X} onError={onImageError(DEFAULT_X)} />
export const onImageError = (fallbackSrc) => (e) => {
  e.target.onerror = null;
  e.target.src = fallbackSrc;
};
